/* eslint-disable no-console */
import React from 'react';

import { Box, Typography } from '@mui/material';

import BookingCancelledToggle from './BookingCancelledToggle';
import RefundAmount from './RefundAmount';
import RefundVendorAgrees from './RefundVendorAgrees';

export default function CustomRefundVariant(props) {
  const shouldDisallowTourCancellation = props.refund.is_tour && props.refund.is_tour_with_active_optional_extras;
  return (
    <Box id="CustomRefundVariant">
      <RefundVendorAgrees
        handleValueChange={props.handleValueChange}
        refund_vendor_agrees_to={props.refund.refund_vendor_agrees_to}
        refund={props.refund}
      />
      <RefundAmount
        tmpValue={props.tmpValue}
        handleTmpChange={props.handleTmpChange}
        itemRefund={props.itemRefund}
        itemRefundOriginal={props.itemRefundOriginal}
        refund={props.refund}
      />
      {shouldDisallowTourCancellation && (
        <>
          <Typography color="red"> This tour is not cancellable as there's an active Optional Extra</Typography>
          <Typography color="red">
            {' '}
            To additionally cancel this tour the Optional Extras must be cancelled first
          </Typography>
        </>
      )}
      {!shouldDisallowTourCancellation && !props.refund.is_subscription && (
        <BookingCancelledToggle
          handleFlagChange={props.handleFlagChange}
          mark_cancelled={props.refund.mark_cancelled}
        />
      )}
    </Box>
  );
}
